<div class="environmental-graph-container">
    <div class="graph-header">
        <h3 class="graph-title">Environmental Monitoring</h3>

        <!-- Filters Row -->
        <div class="filters-row">
            <!-- House Filter -->
            <div class="filter-group">
                <label for="houseSelect">House</label>
                <select
                    id="houseSelect"
                    class="filter-select"
                    [(ngModel)]="selectedHouseId"
                    (change)="onHouseChange()"
                >
                    <option *ngFor="let house of houses" [ngValue]="house.id">
                        {{ house.name }}
                    </option>
                </select>
            </div>

            <!-- Date Range -->
            <div class="filter-group">
                <label for="startDate">Start Date</label>
                <input
                    type="datetime-local"
                    id="startDate"
                    class="filter-input"
                    [(ngModel)]="startDate"
                    (change)="onDateChange()"
                />
            </div>
            <div class="filter-group">
                <label for="endDate">End Date</label>
                <input
                    type="datetime-local"
                    id="endDate"
                    class="filter-input"
                    [(ngModel)]="endDate"
                    (change)="onDateChange()"
                />
            </div>

            <!-- Sensor Type Tabs -->
            <div class="sensor-tabs">
                <button
                    *ngFor="let sensor of sensorTypes"
                    class="sensor-tab"
                    [class.active]="selectedSensorType === sensor.id"
                    (click)="onSensorTypeChange(sensor.id)"
                >
                    {{ sensor.label }}
                </button>
            </div>
        </div>
    </div>

    <!-- Graph Container -->
    <div class="chart-wrapper">
        <!-- Loading State -->
        <div *ngIf="isLoading" class="loading-overlay">
            <div class="spinner"></div>
            <span>Loading data...</span>
        </div>

        <!-- Error Message -->
        <div *ngIf="errorMessage && !isLoading" class="error-message">
            <i class="fas fa-exclamation-circle"></i>
            <span>{{ errorMessage }}</span>
        </div>

        <!-- Chart Canvas -->
        <canvas id="environmentalTimeSeriesChart"></canvas>
    </div>

    <!-- Info Note -->
    <div class="info-note">
        <i class="fas fa-info-circle"></i>
        <span>
            <strong>Note:</strong> Predictions start after 15 hours of actual
            data (60 readings at 15-minute intervals).
            <span class="legend-item actual">━ Actual</span>
            <span class="legend-item predicted">┅ Predicted</span>
        </span>
    </div>
</div>
